export default __webpack_public_path__ + "static/media/ru.b4132869.svg";